import React from "react";

export default function SocialMediaGallery() {
  return (
    <div>
      <div className="container page-top pt-5" style={{ paddingTop: "6rem" }}>
        <h2 className="text-center mt-5 mb-4">
          <span className="text-danger fw-bold blink">Live</span> Social Media Highlights
        </h2>

        <div className="row justify-content-center g-4" style={{ marginTop: "3rem" }}>

          {/* Facebook Post 1 */}
          <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center" data-aos="fade-up">
            <iframe
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0Xe3QUqq1H5x137jHPtrRUhG7TQvJLmZsUQ1PQwQYE7tDTXGQPHv9MvC8AEViPJaml%26id%3D61563516873369&show_text=true&width=500"
              width="500"
              height="500"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>

          {/* Facebook Post 2 */}
          <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center" data-aos="fade-up">
            <iframe
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid0EVuLFC7gAvWWVADWwYohdRHw7yb5W5Yo8pD3159qeM2AR72QmZG5udGuAv5NyZqGl%26id%3D61563516873369&show_text=true&width=500"
              width="500"
              height="500"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>

          {/* LinkedIn Post */}
          <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center" data-aos="fade-up">
            <iframe
              src="https://www.linkedin.com/embed/feed/update/urn:li:share:7419802201474162689"
              width="500"
              height="500"
              frameBorder="0"
              allowFullScreen
              title="LinkedIn Post"
            ></iframe>
          </div>

        </div>
      </div>

      {/* Instagram embed script placeholder */}
      <script async defer src="//www.instagram.com/embed.js"></script>
    </div>
  );
}
